module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.07b84a23.svg";